export const theme = {
  headerLineHeight: '1.4',
};
